module.exports = __webpack_public_path__ + "img/logo_only_text.c9aa0a38.png";